module.exports = __webpack_public_path__ + "static/media/17_CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_04.644b6d30.jpg";